import { isPlatformBrowser } from '@angular/common';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { User } from '../models/user';

type TawkApi = {
  onLoad?: () => void;
  setAttributes?: (
    attributes: Record<string, string>,
    callback?: (error?: unknown) => void
  ) => void;
  logout?: (callback?: (error?: unknown) => void) => void;
};

declare global {
  interface Window {
    Tawk_API?: TawkApi;
  }
}

@Injectable({
  providedIn: 'root',
})
export class TawkService {
  constructor(@Inject(PLATFORM_ID) private platformId: object) {}

  setVisitor(user: User): void {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }

    const tawkApi = (window.Tawk_API = window.Tawk_API || {});
    const name = [user.fname, user.lname].filter(Boolean).join(' ');
    const attributes: Record<string, string> = {
      name: name || user.email,
      email: user.email,
    };

    if (user.tawk_hash) {
      attributes['hash'] = user.tawk_hash;
    }

    this.runWhenReady(tawkApi, () => {
      tawkApi.setAttributes?.(attributes, (error?: unknown) => {
        if (error) {
          console.warn('Failed to set Tawk visitor attributes', error);
        }
      });
    });
  }

  logout(): void {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }

    const tawkApi = window.Tawk_API;
    if (typeof tawkApi?.logout !== 'function') {
      return;
    }

    tawkApi.logout((error?: unknown) => {
      if (error) {
        console.warn('Failed to logout Tawk visitor', error);
      }
    });
  }

  private runWhenReady(tawkApi: TawkApi, callback: () => void): void {
    if (typeof tawkApi.setAttributes === 'function') {
      callback();
      return;
    }

    const previousOnLoad = tawkApi.onLoad;
    tawkApi.onLoad = () => {
      previousOnLoad?.();
      callback();
    };
  }
}
